import { createFileRoute } from '@tanstack/react-router';

import { DiscordLfgBotLanding } from '#features/discord-lfg-bot/components/DiscordLfgBotLanding';
import { BOT_FAQ, BOT_INVITE_URL } from '#features/discord-lfg-bot/data';
import { staticPageHead } from '#features/static-pages/utils/head';

const SITE_URL = 'https://teamplay.gg';
const PAGE_URL = `${SITE_URL}/discord-lfg-bot`;

// Keyword-first title (<60 chars) targeting "discord lfg bot" and its variants.
const title = 'Discord LFG Bot for Gaming Communities | Teamplay LFG';
const description =
  'Free Discord LFG bot: structured LFG posts, scheduled sessions with DM reminders, auto ' +
  'voice channels and cross-server teammate finding. Live in 2 minutes.';
const keywords =
  'discord lfg bot, lfg bot, discord looking for group bot, find teammates discord, ' +
  'discord matchmaking bot, lfg discord, gaming community bot, discord bot for gamers';

const jsonLd = [
  // The bot as a product: eligible for software rich results, price shown as free.
  {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Teamplay LFG – Discord Bot',
    applicationCategory: 'GameApplication',
    operatingSystem: 'Discord',
    url: PAGE_URL,
    installUrl: BOT_INVITE_URL,
    image: `${SITE_URL}/preview.png`,
    description,
    offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
    publisher: {
      '@type': 'Organization',
      name: 'Teamplay',
      url: SITE_URL,
      logo: `${SITE_URL}/android-chrome-512x512.png`,
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Teamplay', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'Discord LFG Bot', item: PAGE_URL },
    ],
  },
  // FAQ rich results, generated from the same data the on-page FAQ renders.
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: BOT_FAQ.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  },
];

export const Route = createFileRoute('/{-$locale}/_layout/discord-lfg-bot/')({
  // The landing ships its own LFG-branded header (section anchors + invite CTA) and
  // footer (bot links + App legal docs), so the global teamplay.gg chrome is suppressed.
  staticData: { rendersOwnHeader: true, rendersOwnFooter: true },
  component: DiscordLfgBotLanding,
  head: () =>
    staticPageHead({ title, description, keywords, pathname: '/discord-lfg-bot', jsonLd }),
});
